import { render } from "./AlarmDelete.vue?vue&type=template&id=36f9de14"
import script from "./AlarmDelete.vue?vue&type=script&lang=js"
export * from "./AlarmDelete.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__